/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rails_Platforms_LessInputs */

const en_directory_rails_platforms_less = /** @type {(inputs: Directory_Rails_Platforms_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show less`)
};

const zh_directory_rails_platforms_less = /** @type {(inputs: Directory_Rails_Platforms_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收起`)
};

/**
* | output |
* | --- |
* | "Show less" |
*
* @param {Directory_Rails_Platforms_LessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_platforms_less = /** @type {((inputs?: Directory_Rails_Platforms_LessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_Platforms_LessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_platforms_less(inputs)
	return zh_directory_rails_platforms_less(inputs)
});
export { directory_rails_platforms_less as "directory.rails.platforms_less" }